import { render, staticRenderFns } from "./clientRefundDetail.vue?vue&type=template&id=59dd27f3&"
import script from "./clientRefundDetail.vue?vue&type=script&lang=js&"
export * from "./clientRefundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports